import '../utils';

function formatPackagingFormat(format){ // CAJA -> Cajas
    let firstCharacter = format.substring(0,1);
    let restToLower = format.substring(1, format.length).toLowerCase()

    return firstCharacter + restToLower + 's';
}
export default {

    accordionCollapseStates: state => state.accordionCollapseStates,
    accordionCollapseStateById: state => id => state.accordionCollapseStates.find(a => a.id == id),

    rows: state => state.rows,
    rowByKey: state => key => state.rows.find(r => r.key == key),
    formattedRowInfo: state => key => {
        let row = state.rows.find(r => r.key == key);
        if(!row) return false;

        let isStation = row.type == 'station';
        let name = row.data.descrip + (isStation ? '' : (' - uc: ' + row.data.last_unit_value));

        return {
            state:              row.data.equipment_state_id,
            name:               name,
            ...(isStation && {packaging: formatPackagingFormat(row.data.packaging_format_descrip) }),
            completedPercentage:row.data.completed_percentage,
            quantity:           Utils.round(row.data.parent_partial_quantity, 1),
            okQuantity:         Utils.round(row.data.ok_quantity),
            delayedQuantity:    Utils.round(row.data.delayed_quantity),
            stopsTime:          row.data.total_stops_time,
        }
    }
}
